import React from "react";

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet my Team</h2>
          <p>
          At the core of our mission lies a profound belief: a genuine and transparent client relationship is the cornerstone of every triumph in collaboration. We don't just aim for success; we strive for a partnership forged in understanding and respect. Your journey with us isn't just a project; it's a commitment to excellence, integrity, and a shared vision. Let's build something exceptional together.
          </p>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
                  <div className="thumbnail">
                    {" "}
                    <img src={d.img} alt="..." className="team-img" />
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
